module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/user-bundle-dialog/component.scss
// module id = ./src/modules/admin/dialogs/user-bundle-dialog/component.scss
// module chunks = main